import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import SignIn from './components/SignIn';
import Layout from './components/Layout';
import Dashboard from './views/Dashboard';
import GoalsTasks from './views/GoalsTasks';
import Initiatives from './views/Initiatives';
import Actions from './views/Actions';
import CalendarView from './views/CalendarView';
import UnitHealth from './views/UnitHealth';
import Contacts from './views/Contacts';
import OrgChart from './views/OrgChart';
import Commissioners from './views/Commissioners';
import UnitMap from './views/UnitMap';
import StrategicPlan from './views/StrategicPlan';
import Communications from './views/Communications';
import Settings from './views/Settings';
import FosShell from './views/fos/FosShell';
import FosHome from './views/fos/FosHome';
import FosDonors from './views/fos/FosDonors';
import FosDonorDetail from './views/fos/FosDonorDetail';
import FosContributions from './views/fos/FosContributions';
import FosGoals from './views/fos/FosGoals';
import FosFollowUps from './views/fos/FosFollowUps';
import { isAdmin } from './lib/visibility';
import { configError } from './firebase';
import { PRODUCT_NAME } from './branding';

function Unprovisioned() {
  const { firebaseUser, signOut } = useAuth();
  return (
    <div className="center">
      <div className="signin">
        <h1>Almost there</h1>
        <p>
          You're signed in as <b>{firebaseUser?.email}</b>, but this account
          hasn't been added to {PRODUCT_NAME} yet. Ask your {PRODUCT_NAME}
          administrator to set up your access.
        </p>
        <button className="btn" onClick={signOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}

export default function App() {
  const { loading, firebaseUser, profile, unprovisioned } = useAuth();

  if (configError) {
    return (
      <div className="center">
        <div className="signin">
          <h1>{PRODUCT_NAME}</h1>
          <p className="err">{configError}</p>
        </div>
      </div>
    );
  }

  if (loading) return <div className="center">Loading…</div>;
  if (!firebaseUser) return <SignIn />;
  if (unprovisioned || !profile) return <Unprovisioned />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="goals" element={<GoalsTasks />} />
        <Route path="initiatives" element={<Initiatives />} />
        <Route path="actions" element={<Actions />} />
        <Route path="calendar" element={<CalendarView />} />
        <Route path="units" element={<UnitHealth />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="org" element={<OrgChart />} />
        <Route path="commissioners" element={<Commissioners />} />
        <Route path="unit-map" element={<UnitMap />} />
        <Route path="coverage" element={<Navigate to="/unit-map" replace />} />
        <Route path="strategy" element={<StrategicPlan />} />
        <Route path="communications" element={<Communications />} />
        <Route path="fos" element={<FosShell />}>
          <Route index element={<FosHome />} />
          <Route path="donors" element={<FosDonors />} />
          <Route path="donors/:donorId" element={<FosDonorDetail />} />
          <Route path="contributions" element={<FosContributions />} />
          <Route path="goals" element={<FosGoals />} />
          <Route path="follow-ups" element={<FosFollowUps />} />
          <Route path="*" element={<Navigate to="/fos" replace />} />
        </Route>
        <Route
          path="settings"
          element={isAdmin(profile) ? <Settings /> : <Navigate to="/" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
